import React, { useRef } from "react";

import AnimateOnHover from "jd-library/AnimateOnHover";
import toastMessageActions from "jd-library/toastMessageActions";

const ProductBankIdCopy = ({
  productBankId = "",
  copyLabel = "",
  isMobile,
  styles = [],
  showToastMessage = toastMessageActions.showMessage
}) => {
  const copyCodeToClipboard = () => {
    if(navigator.clipboard) {
      navigator.clipboard.writeText(productBankId).then(() => {
        console.log('ProductBankId copied');
        showToastMessage({
          showToastMessage: true,
          message: "Product Bank ID Copied",
          type: "info",
          duration: 5000,
        });  
      }).catch(err => {
        console.log('Failed to Copy :',err);
      })
    }else {
      var myTemporaryInputElement = document.createElement("input");
      myTemporaryInputElement.type = "text";
      myTemporaryInputElement.value = productBankId;
      document.body.appendChild(myTemporaryInputElement);
      myTemporaryInputElement.select();
      document?.execCommand && document.execCommand("Copy");
      if (document.body.contains(myTemporaryInputElement)) {
        document.body.removeChild(myTemporaryInputElement);  
      }
            
      showToastMessage({
        showToastMessage: true,
        message: "Product Bank ID Copied",
        type: "info",
        duration: 5000,
      });
    }
  };

  return (
    <div className={styles["user-details-productbankid"]}>
      {copyLabel && (
        <span className={styles["copy-label"]}>
          <span className={styles["copy-label-text"]}>{copyLabel} :&nbsp;</span>
          {productBankId}
        </span>
      )}
      {isMobile ? (
        <div
          className={styles["product-id-copy-holder"]}
          onClick={() => copyCodeToClipboard()}
        >
          <span
            className={styles["product-id-copy-icon"] + " icon-Copy"}
          ></span>
          COPY
        </div>
      ) : (
        <AnimateOnHover
          className={styles["product-id-copy-holder"]}
          onClick={() => copyCodeToClipboard()}
        >
          <span
            className={styles["product-id-copy-icon"] + " icon-Copy"}
          ></span>
          COPY
        </AnimateOnHover>
      )}
    </div>
  );
};

export default ProductBankIdCopy;
